import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { LocalVoucherResponse } from "../model/voucher";
import { InternationalGiftCardResponse, LocalGiftCardResponse, VoucherRequest } from './../model/voucher';


export const VOUCHER_LOCAL_FEE = 'VOUCHER_KIOSK'
@Injectable({
  providedIn: 'root'
})
export class VoucherService {
  constructor() {
  }
  private lv: Subject<Array<LocalVoucherResponse>> = new BehaviorSubject<Array<LocalVoucherResponse>>([] as any);
  private lgc: Subject<Array<LocalGiftCardResponse>> = new BehaviorSubject<Array<LocalGiftCardResponse>>([] as any);
  private igc: Subject<Array<InternationalGiftCardResponse>> = new BehaviorSubject<Array<InternationalGiftCardResponse>>([] as any);
  private page: Subject<string> = new Subject<string>();
  private inputs: Subject<VoucherRequest> = new BehaviorSubject<VoucherRequest>({} as any);
  private isDisabled: Subject<boolean> = new BehaviorSubject<boolean>(true);
  private denomination: Subject<any> = new BehaviorSubject<any>("");
  private mobileNumber: Subject<any> = new BehaviorSubject<any>("");
  private result: Subject<any> = new BehaviorSubject<any>("");
  private allowCancel: Subject<boolean> = new BehaviorSubject<boolean>(true);

  get localVoucherList$() {
    return this.lv.asObservable();
  }

  get localGCList$() {
    return this.lgc.asObservable();
  }

  get internationalGCList$() {
    return this.igc.asObservable();
  }

  get inputRequest$() {
    return this.inputs.asObservable();
  }

  get pageNumber$() {
    return this.page.asObservable();
  }

  get getDisabled$() {
    return this.isDisabled.asObservable();
  }

  get getDenomination$() {
    return this.denomination.asObservable();
  }

  get getMobileNumber$() {
    return this.mobileNumber.asObservable();
  }

  get getResult$() {
    return this.result.asObservable();
  }

  get getPage$() {
    return this.page.asObservable();
  }

  get getAllowCancel$() {
    return this.allowCancel.asObservable();
  }

  addLocalVoucherList(data: Array<LocalVoucherResponse>) {
    this.lv.next(data);
  }

  addLocalGCList(data: Array<LocalGiftCardResponse>) {
    this.lgc.next(data);
  }

  addInternationalGCList(data: Array<InternationalGiftCardResponse>) {
    this.igc.next(data);
  }

  updateInputs(data: VoucherRequest) {
    this.inputs.next(data);
  }

  updatePage(data: string) {
    this.page.next(data);
  }

  updateButtonDisable(data: boolean) {
    this.isDisabled.next(data);
  }

  updateDenomination(data: any) {
    this.denomination.next(data);
  }

  updateMobileNumber(data: any) {
    this.mobileNumber.next(data);
  }

  updateResult(data: any) {
    this.result.next(data);
  }

  updateAllowCancel(data: any) {
    this.allowCancel.next(data);
  }

}
